import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function PortfolioCTASection() {
  return <section className="portfolio-cta-section" style={{
    background: '#5a4579',
    padding: '60px 20px',
    borderTopLeftRadius: '32px',
    borderTopRightRadius: '32px',
    marginTop: '-24px',
    position: 'relative'
  }} data-id="element-348">
      <style data-id="element-349">{`
        @media (min-width: 769px) {
          .portfolio-cta-section { padding: 80px 40px !important; }
        }
      `}</style>
      <div className="max-w-2xl mx-auto" style={{
      textAlign: 'center'
    }} data-id="element-350">
        <motion.p initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} style={{
        color: 'rgba(255,255,255,0.55)',
        fontSize: '11px',
        fontWeight: 700,
        letterSpacing: '2px',
        textTransform: 'uppercase',
        marginBottom: '12px'
      }} data-id="element-351">
          ¿Listo para empezar?
        </motion.p>
        <motion.h2 initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.05
      }} className="text-[26px] md:text-[34px]" style={{
        color: '#FFFFFF',
        fontWeight: 800,
        lineHeight: 1.2,
        marginBottom: '14px'
      }} data-id="element-352">
          ¿Quieres una landing page{' '}
          <span className="italic" style={{
          color: '#D4A5D8'
        }} data-id="element-353">
            así
          </span>{' '}
          para tu negocio?
        </motion.h2>
        <motion.p initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} style={{
        color: 'rgba(255,255,255,0.75)',
        fontSize: '15px',
        lineHeight: 1.6,
        maxWidth: '520px',
        margin: '0 auto 28px'
      }} data-id="element-354">
          Te la creamos en español, con copy estratégico, diseño profesional y
          lista para vender desde el día uno.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.15
      }} className="flex flex-col items-center" style={{
        gap: '16px'
      }} data-id="element-355">
          <a href="#plan-2" className="inline-flex items-center justify-center transition-all" style={{
          background: '#FFFFFF',
          color: '#5a4579',
          borderRadius: '12px',
          padding: '14px 28px',
          fontSize: '15px',
          fontWeight: 800,
          gap: '8px',
          boxShadow: '0 8px 24px rgba(0,0,0,0.25)'
        }} onMouseEnter={e => {
          const el = e.currentTarget as HTMLAnchorElement;
          el.style.transform = 'translateY(-2px)';
          el.style.boxShadow = '0 12px 32px rgba(0,0,0,0.35)';
        }} onMouseLeave={e => {
          const el = e.currentTarget as HTMLAnchorElement;
          el.style.transform = 'translateY(0)';
          el.style.boxShadow = '0 8px 24px rgba(0,0,0,0.25)';
        }} data-id="element-356">
            Quiero mi landing page
            <ArrowRight size={18} strokeWidth={2.2} data-id="element-357" />
          </a>

          <a href="https://wa.me/17863037695?text=Hola%2C%20quiero%20una%20sesi%C3%B3n%20estrat%C3%A9gica%20gratuita%20con%20Inkova." target="_blank" rel="noopener noreferrer" style={{
          color: '#FFFFFF',
          fontSize: '14px',
          fontWeight: 500,
          textDecoration: 'underline',
          textUnderlineOffset: '4px'
        }} data-id="element-358">
            Primero quiero una sesión gratuita
          </a>
        </motion.div>
      </div>
    </section>;
}